import Api from './Api';

export default {
    listPackage(req) {
        const api = Api.generateApi();
        return api
            .get(
                'packages/list?' +
                'sort=' +
                req.sort +
                '&page=' +
                req.page +
                '&per_page=' +
                req.per_page +
                '&search=' +
                req.search
            )
            .then(res => res);
    },

    createPackage(req) {
        const api = Api.generateApi();
        return api.post('packages/create', req).then(res => res);
    },

    editPackage(req) {
        const api = Api.generateApi();
        return api.put('packages/update/' + req.id, req).then(res => res);
    },

    detailPackage(req) {
        const api = Api.generateApi();
        return api.get('packages/detail/' + req.id).then(res => res);
    },

    deletePackage(req) {
        const api = Api.generateApi();
        return api.delete('packages/delete/' + req.id).then(res => res);
    }
};